import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Spinner from 'ui-library/Spinner';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export enum UploadStatus {
  UPLOADING = 'uploading',
  COMPLETE = 'complete',
  FAILED = 'failed',
  PENDING = 'pending',
}

export interface FilesPickerItemProps {
  name: string;
  status: UploadStatus;
}

function FilesPickerItem({name, status}: FilesPickerItemProps): JSX.Element {
  return (
    <td>
      <span className="pull-right">
        {status === UploadStatus.UPLOADING ? (
          <Spinner classNames={css(styles.spinner)} />
        ) : status === UploadStatus.COMPLETE ? (
          <span className="glyphicon glyphicon-ok" />
        ) : status === UploadStatus.FAILED ? (
          <span className="glyphicon glyphicon-exclamation-sign" />
        ) : status === UploadStatus.PENDING ? (
          <span className="glyphicon glyphicon-trash delete u-danger-pointer" />
        ) : null}
      </span>
      <span className="name">
        <span className="glyphicon glyphicon-file files-picker-icon" />
        <span {...getTestProps({component: 'FilesPickerItem', element: 'fileName'})}>{name}</span>
      </span>
    </td>
  );
}

const styles = StyleSheet.create({
  spinner: {
    margin: 0,
  },
});

export default makeDeprecatedJadeStyleTemplate<FilesPickerItemProps>(FilesPickerItem);
